import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { InvoiceGroupedList } from "@/components/invoices/InvoiceGroupedList";

interface Invoice {
  id: string;
  payment_amount: number;
  payment_due_date: string;
  supplier_name: string;
  supplier_email: string;
  status: string;
  discount_amount: number | null;
  discounted_payment_amount: number | null;
  created_at: string;
}

interface SupplierInvoicesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  supplierName: string;
  supplierEmail: string;
  invoices: Invoice[];
  onBack?: () => void;
}

export function SupplierInvoicesModal({
  open,
  onOpenChange,
  supplierName,
  supplierEmail,
  invoices,
  onBack,
}: SupplierInvoicesModalProps) {
  const supplierInvoices = invoices.filter((i) => i.supplier_email === supplierEmail);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          {onBack && (
            <Button variant="ghost" size="sm" className="w-fit -ml-2 mb-1 text-xs" onClick={onBack}>
              <ArrowLeft className="w-3.5 h-3.5 mr-1" /> Back to Suppliers
            </Button>
          )}
          <DialogTitle>{supplierName}</DialogTitle>
          <DialogDescription>{supplierInvoices.length} invoice(s)</DialogDescription>
        </DialogHeader>
        <InvoiceGroupedList
          invoices={supplierInvoices}
          emptyMessage="No invoices for this supplier"
          maxHeight="400px"
        />
      </DialogContent>
    </Dialog>
  );
}
